import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import BulletList from '../lists/BulletList';

const InfoBox = ({ title, description, list }) => (
  <Box sx={{
    bgcolor: 'info.A100',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'info.A400',
    borderRadius: '12px',
    p: 2,
  }}
  >
    <Typography variant="small_3" fontWeight={700} textAlign="center" display="block" mb={1} sx={{ color: 'gray.A700' }}>
      {title}
    </Typography>
    <Typography variant="small_3" sx={{ color: 'gray.A500' }}>
      {description}
    </Typography>
    <BulletList list={list} typographyVariant="small_3" />
  </Box>
);

InfoBox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string),
};

InfoBox.defaultProps = {
  title: 'Importante',
  description: '',
  list: [],
};

export default InfoBox;
